import { render, staticRenderFns } from "./quotes.vue?vue&type=template&id=c2a164e2&scoped=true&"
import script from "./quotes.vue?vue&type=script&lang=js&"
export * from "./quotes.vue?vue&type=script&lang=js&"
import style0 from "./quotes.vue?vue&type=style&index=0&id=c2a164e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a164e2",
  null
  
)

export default component.exports